export enum PlanOptions {
    SplendFlexiOwn = 'Splend Flexi-Own',
    SplendFlexi = 'Splend Flexi',
    SplendRentToOwnUsedVehicle = 'Splend Rent to Own - Used Vehicle',
    RAVCreditHire = 'RAV Credit Hire',
    RAVSharecover = 'RAV Sharecover',
    RAVShortTermRental = 'RAV Short Term Rental',
    CancellationShareCover = 'RAV Share Cover',
    CancellationFlexiOwn = 'Flexi Own',
    RAVIAG = 'RAV IAG',
    RAVFirstPartyHire = 'RAV First Party Hire',
    RAVFirstPartyHireEV = 'RAV First Party Hire EV',
    RAVCreditHireEV = 'RAV Credit Hire EV',

    UKFlexiOwn = 'Flexi-own',
    UKFlexi = 'Splend Rent',
    UKRentToOwnUsed = 'Pre-Loved Flexi-Own',
    PHAVCreditHire = 'PHAV Credit Hire',
    PHAVShortTermRental = 'PHAV Short Term Rental',
    PremiumPHAVCreditHire = 'Premium PHAV Credit Hire',

    QuoteOnboard = 'Flexi Own',
    UberEQEPromo = 'Uber HP Bundle Promo',
    UberEQECarOnlyPromo = 'Uber HP Car Only Promo'
};


// Values map what at origin are the possible
// values for the Zoho Potential record Plan Preference
// field on the UI or Plan field from the BE response (
// pricing record endpoint).
export enum AUPotentialPlanPreference {
    FlexiOwn = "Flexi own",
    PreOwnedFlexiOwn = "Pre-Owned Flexi Own",
    Flexi = "Flexi",
    RAVCreditHire = "RAV Credit Hire"
};

export enum GBPotentialPlanPreference {
    FlexiOwn = "Flexi Own",
    PreLovedFlexiOwn = 'Pre-Loved Flexi-Own',
};


// Values are a subset of the AUPotentialPlanPreference
// enum and are intended to reflect the allowed plans
// for a FOv2 onboarding.
export enum CBPAllowedPlans {
    SplendFlexiOwn = 'Splend Flexi-Own',
    SplendRentToOwnUsedVehicle = 'Splend Rent to Own - Used Vehicle',
    SplendFlexi = 'Splend Flexi',
    GBFlexiOwn = 'Flexi-own', // temp value for UK FOv2
    PreLovedFlexiOwn = 'Pre-Loved Flexi-Own',
};
